import React from "react";
import { InquiryStatus } from "../../../../domain/inquiry/Inquiry";

export default function InquiryStatusLabel(props: Props) {

    const { status } = props;

    const toStatusLabel = (status: InquiryStatus): { label: string, className: string } => {
        switch(status) {
            case "NEW":
                return { label: "新規", className: "new" };
            case "IN_PROGRESS":
                return { label: "対応中", className: "in_progress" };
            case "RESOLVED":
                return { label: "解決済", className: "resolved" };
            case "CLOSED":
                return { label: "完了", className: "closed" };
        }
    };

    const { label, className } = toStatusLabel(status);

    return (
        <div className={`inquiry_status__${className}`}>
            { label }
        </div>
    );

}

type Props = {
    status: InquiryStatus
}